import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "placeholder", "required", "type", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "mb-2 text-sm font-medium text-gray-900 dark:text-white"
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: _ctx.id,
      placeholder: _ctx.placeholder,
      required: _ctx.required,
      type: _ctx.type,
      value: _ctx.modelValue,
      class: "bg-white border-[0.2px] border-gray-300 text-gray-900 text-sm focus:ring-primary focus:border-primary block w-full p-2.5",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
    }, null, 40, _hoisted_3)
  ]))
}